import { Link } from 'react-router-dom'
import { BrandLogo } from '@/components/brand-logo'
import { BRAND_NAME } from '@/lib/branding'

export function SiteFooter() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="border-t border-zinc-200 bg-zinc-50">
      <div className="container mx-auto px-4 py-8 md:py-14">
        <div className="mx-auto max-w-5xl">
          {/* Mobile footer: compact and action-oriented */}
          <div className="space-y-4 text-center md:hidden">
            <div className="flex items-center justify-center">
              <BrandLogo size="lg" />
            </div>
            <p className="mx-auto max-w-xs text-sm leading-relaxed text-zinc-600">
              One featured gear review each week, plus discounted past reviews.
            </p>

            <nav
              aria-label="Footer quick links"
              className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2"
            >
              <Link
                to="/"
                className="text-sm font-medium text-zinc-600 transition-colors hover:text-red-600"
              >
                This Week
              </Link>
              <Link
                to="/past-reviews"
                className="text-sm font-medium text-zinc-600 transition-colors hover:text-red-600"
              >
                Past Reviews
              </Link>
              <Link
                to="/about"
                className="text-sm font-medium text-zinc-600 transition-colors hover:text-red-600"
              >
                About
              </Link>
            </nav>

            <p className="text-sm text-zinc-600">
              Need help?{' '}
              <Link
                to="/contact"
                className="font-semibold text-red-600 transition-colors hover:text-red-700"
              >
                Contact Us
              </Link>
            </p>
          </div>

          {/* Desktop footer: full information architecture */}
          <div className="hidden gap-10 text-center md:grid md:grid-cols-3 md:gap-8">
            <div>
              <div className="mb-3 flex items-center justify-center">
                <BrandLogo size="lg" />
              </div>
              <p className="mx-auto max-w-xs text-sm leading-relaxed text-zinc-600">
                One featured gear review each week, plus discounted past reviews
                you can buy anytime.
              </p>
            </div>
            <div>
              <h4 className="mb-3 text-sm font-semibold uppercase tracking-wide text-zinc-900">
                Quick Links
              </h4>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/"
                    className="text-sm text-zinc-600 transition-colors hover:text-red-600"
                  >
                    This Week
                  </Link>
                </li>
                <li>
                  <Link
                    to="/past-reviews"
                    className="text-sm text-zinc-600 transition-colors hover:text-red-600"
                  >
                    Past Reviews
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-zinc-600 transition-colors hover:text-red-600"
                  >
                    About
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="mb-3 text-sm font-semibold uppercase tracking-wide text-zinc-900">
                Contact
              </h4>
              <p className="mx-auto mb-3 max-w-xs text-sm leading-relaxed text-zinc-600">
                Questions, feedback, or gear suggestions? Send us a message
                through the contact form.
              </p>
              <Link
                to="/contact"
                className="inline-flex items-center text-sm font-medium text-red-600 transition-colors hover:text-red-700"
              >
                Contact Us
              </Link>
            </div>
          </div>

          <div className="mt-6 border-t border-zinc-200 pt-5 text-center md:mt-10 md:pt-6">
            <p className="text-sm text-zinc-500">
              &copy; {currentYear} {BRAND_NAME}. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}
